module.exports = __webpack_public_path__ + "static/media/diabetic-foot-assessment.386dbaac.jpg";